import {createAction, props} from '@ngrx/store';
import {BuildingDetails} from '@shared/models/building-details';
import {MeterData} from 'src/app/meter/meter-data/meter-data.model';
import {User} from '@shared/services/user.service';
import {Location} from '@shared/services/location.service';

// Building actions
export const loadBuilding = createAction('Load building', props<{buildingNo: string}>());
export const loadBuildingSuccess = createAction(
    'Load building success',
    props<{building: BuildingDetails}>(),
);
export const loadBuildingFailure = createAction('Load building failure', props<{error: string}>());

// Meter actions
export const loadMeter = createAction('Load meter', props<{buildingNo: string; meterId: string}>());
export const loadMeterSuccess = createAction('Load meter success', props<{meter: MeterData}>());
export const loadMeterFailure = createAction('Load meter failure', props<{error: string}>());

// User actions
export const loadUser = createAction('Load user');
export const loadUserSuccess = createAction('Load user success', props<{user: User}>());
export const loadUserFailure = createAction('Load user failure', props<{error: string}>());
export const logOut = createAction('Log out');

// Location actions
export const loadLocation = createAction(
    'Load location',
    props<{buildingNo: string; locationId: string}>(),
);
export const loadLocationSuccess = createAction(
    'Load location success',
    props<{location: Location}>(),
);
export const loadLocationFailure = createAction('Load location failure', props<{error: string}>());
